// extracted by mini-css-extract-plugin
export default {"headline":"GmailContactList--headline--odhv-"};